// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shopAllProductsLinkStyles } from "@guestsupply/App/Widgets/BrandDetails/ShopAllProductsLink";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const commonTypographyStyles: TypographyProps = {
    size: 16,
    weight: 400,
    css: css`
        margin-bottom: 0;
    `,
};

shopAllProductsLinkStyles.productLinkItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        padding-right: 15px;
    `,
};

shopAllProductsLinkStyles.fullWidthProductLinkItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

shopAllProductsLinkStyles.externalLinkItem = {
    width: 6,
    css: css`
        padding-left: 15px;
        justify-content: flex-start;
    `,
};

shopAllProductsLinkStyles.linksContainer = {
    gap: 0,
    css: css`
        margin-bottom: 0px;
    `,
};

shopAllProductsLinkStyles.externalLink = {
    typographyProps: commonTypographyStyles,
    css: css`
        text-align: center;
        text-transform: capitalize;
    `,
};

shopAllProductsLinkStyles.productLink = {
    typographyProps: commonTypographyStyles,
    css: css`
        text-align: center;
        text-transform: capitalize;
    `,
};
